import React, { useState } from "react";
import { CSVLink } from "react-csv";

export default function ExportToExcle(props) {
  const { Data } = props;
  console.log(props);
  const [ExportData, setExportData] = useState({
    dataExport: "",
  });
  const changeHandler = (value) => {
    setExportData({ dataExport: Data });
  };

  const data = ExportData.dataExport;

  const headers = [
    { label: "Name", key: "NAME" },
    { label: "Debit", key: "db_amt" },
    { label: " Credit", key: "cr_amt" },
  ];
  //   const headers1 = [{ label: "Trial Balance", key: "" }];

  const csvReport = {
    filename: "Report.csv",
    headers: headers,
    data: data,
  };

  return (
    <>
      <div>
        <CSVLink
          {...csvReport}
          onClick={changeHandler}
          className="btn btn-primary"
        >
          {" "}
          Export To Excel
        </CSVLink>
      </div>
    </>
  );
}
